import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { NotebookComponent } from "./components/NotebookComponent";
import { LoginComponent } from "./components/LoginComponent";
import { RegisterComponent } from "./components/RegisterComponent";
import { LogoutComponent } from "./components/LogoutComponent";
import { TryAgainComponent } from "./components/TryAgainComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("log-out", LogoutComponent);
window.customElements.define("note-book", NotebookComponent);
window.customElements.define("login-page", LoginComponent);
window.customElements.define("register-page", RegisterComponent);
window.customElements.define("try-again", TryAgainComponent);
